import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes =  [
  {
    path: "/",
    name: "main",
    component: () => import("./views/Main.vue"),
    children: [
      {
        path: "",
        name: 'home',
        component: () => import("./views/Home.vue")
      },
      {
        path: "/role",
        name: "role",
        component: () => import("./views/sys/Role.vue")
      },
      {
        path: "/manager",
        name: "manager",
        component: () => import("./views/sys/Manager.vue")
      },
      {
        path: "/navigation",
        name: "navigation",
        component: () => import("./views/sys/Navigation.vue")
      },
      {
        path: "/siteconfig",
        name: "siteconfig",
        component: () => import("./views/sys/SiteConfig.vue")
      },
      {
        path: "/banner",
        name: "banner",
        component: () => import("./views/sys/Banner.vue")
      },
      {
        path: "/articleInfo",
        name: "articleInfo",
        component: () => import("./views/sys/ArticleInfo.vue")
      },
      {
        path: "/articleStatic/:id",
        name: "articleStatic",
        component: () => import("./views/sys/ArticleStatic.vue"),
      },
      {
        path: "/cases",
        name: "cases",
        component: () => import("./views/website/Cases.vue"),
      },
      {
        path: "/product",
        name: "product",
        component: () => import("./views/website/Product.vue"),
      },
      {
        path: "/procate",
        name: "procate",
        component: () => import("./views/website/ProCate.vue"),
      },
      {
        path: "/news",
        name: "news",
        component: () => import("./views/website/News.vue"),
      },
      {
        path: "/feedback",
        name: "feedback",
        component: () => import("./views/website/FeedBack.vue"),
      }

      
    ]
  },
  {
    path: "/login",
    name: "login",
    component: () => import("./views/Login.vue")
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
